// Apply the QA policy after the page and Redux have finished assembling props.
// Some existing pages remove revalidate outside production.
export const withQaRevalidation = (wrapper, currentEnv = process.env.NEXT_PUBLIC_ENV_NAME) => {
  if (currentEnv !== "qa_ssr") return wrapper;

  return {
    ...wrapper,
    getStaticProps: (...args) => {
      const getProps = wrapper.getStaticProps(...args);
      return async (context) => ({
        ...await getProps(context),
        revalidate: 1,
      });
    },
  };
};
